export const EXLY_LANDING_PAGE =
    process.env.NEXT_PUBLIC_LANDING_PAGE_URL ?? "https://exlyapp.com";
